import { Badge } from "react-bootstrap";

function PillLabel({
  name,
  onClick,
  color = "#6b46c1",
  textColor = "#fff",
  className = "",
  disabled = false,
}) {
  return (
    <span
role="button"
onClick={disabled ? undefined : onClick}
style={{
backgroundColor: color,
color: textColor,
cursor: disabled ? "not-allowed" : "pointer",
display: "inline-block",
padding: "0.25rem 0.6rem",
fontSize: "0.75rem",
fontWeight: 500,
lineHeight: 1.2,
borderRadius: "50rem", // pill effect
userSelect: "none",
whiteSpace: "nowrap",
}}
className={className}
>
{name}
</span>
  );
}

export default PillLabel;
